module.exports = __webpack_public_path__ + "img/nordic-transport.2bcd96e8.png";